// extracted by mini-css-extract-plugin
module.exports = {"cart-popup-info-icon":"cart-popup-info-icon_1Nh-P"};